import { Box } from '@mui/material';
import {
  CustomTextField,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
} from '../../../common/components';

const GeneralDataSection = ({ selectedSubcontractor, onInputChange, isMobile }) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos generales
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomTextField
            label="Nombre"
            name="company"
            value={selectedSubcontractor.company || ''}
            onChange={onInputChange}
            size="medium"
            required
          />
          <CustomTextField
            label="Razón social"
            name="legal_business_name"
            value={selectedSubcontractor.legal_business_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="CUIT"
            name="cuit"
            value={selectedSubcontractor.cuit || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="IIBB"
            name="libb"
            value={selectedSubcontractor.libb || ''}
            onChange={onInputChange}
            size="medium"
          />
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Nombre"
              name="company"
              value={selectedSubcontractor.company || ''}
              onChange={onInputChange}
              size="medium"
              required
            />
            <CustomTextField
              label="Razón social"
              name="legal_business_name"
              value={selectedSubcontractor.legal_business_name || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CustomTextField
              label="CUIT"
              name="cuit"
              value={selectedSubcontractor.cuit || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="IIBB"
              name="libb"
              value={selectedSubcontractor.libb || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
        </HorizontalForm>
      )}
    </Box>
  );
};

export default GeneralDataSection;
